/**
 * 控制抽屉开关的功能
 */
import {bus} from '@/bus.js'//引入bus.js定义的空的Vue实例

export const drawerControl = {
  data(){
    return {
        drawerVisible:true,
        mainMapShow:true,
    }
  },
  methods:{
      //打开/关闭抽屉功能需要
      answerBus(){
        bus.$on('drawer',function(){
          this.drawerVisible=!this.drawerVisible;

          this.mainMapShow=false;
          this.$nextTick(() => {//当dom发生变化，更新后执行的回调
            this.mainMapShow=true;
          })
        }.bind(this));
      }

  },
  created(){
    this.answerBus();
  }

}